import { render, staticRenderFns } from "./list2Edit.vue?vue&type=template&id=4f43cb72&scoped=true&"
import script from "./list2Edit.vue?vue&type=script&lang=js&"
export * from "./list2Edit.vue?vue&type=script&lang=js&"
import style0 from "./list2Edit.vue?vue&type=style&index=0&id=4f43cb72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f43cb72",
  null
  
)

export default component.exports